import React from 'react';
import { Link } from 'react-router-dom';

const Activities = () => {
  return (
    <div className="research-page">
      <div className="container">
        <h1 className="page-title">Activities</h1>
        <p className="page-subtitle">Conferences, training opportunities, and networking events for solution-focused professionals</p>
        
        <div className="research-grid">
          <Link to="/conferences" className="research-card">
            <div className="card-icon">🏛️</div>
            <h3>Conferences</h3>
            <p>Annual conferences bringing together professionals from across Europe and beyond. Features keynote speakers, workshops, and networking opportunities.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/summercamp" className="research-card">
            <div className="card-icon">☀️</div>
            <h3>EBTA Summercamp</h3>
            <p>Intensive multi-day training experiences combining learning with networking in beautiful European locations. Perfect for deepening your practice.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/meet-and-learn" className="research-card">
            <div className="card-icon">🎓</div>
            <h3>Meet and Learn</h3>
            <p>Regular learning sessions, special interest groups, and skills development workshops for EBTA members and practitioners.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/awards" className="research-card">
            <div className="card-icon">🏆</div>
            <h3>Awards</h3>
            <p>Recognition of excellence in solution-focused brief therapy, including EBTA Excellence Awards and Research Grant Awards.</p>
            <div className="card-arrow">→</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Activities;
